import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

class V4BundleAdd extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.addPair);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.addPair);
  }

  addPair = async () => {
    if (!this.button || this.button.disabled) return;

    const variantIds = [this.dataset.primaryVariant, this.dataset.addonVariant].filter(Boolean);
    if (variantIds.length !== 2) return;

    const items = variantIds.map((id) => ({ id: Number(id), quantity: 1 }));
    const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')]
      .map((component) => component.dataset.sectionId)
      .filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();

    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');

    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: variantIds.map((id) => ({ merchandiseId: id, quantity: 1 })),
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: sectionIds.join(',') }),
      });
      const result = await response.json();

      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add pair');

      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'v4-bundle-add',
          sourceId: this.id,
          itemCount: 2,
          sections: result.sections,
          didError: false,
        },
      });
      this.button.querySelector('[data-label]').textContent = 'Pair added';
    } catch (error) {
      deferred.reject(error);
      this.dispatchEvent(
        new CartErrorEvent({
          error: error instanceof Error ? error.message : 'Unable to add pair',
          code: 'INVALID',
        })
      );
      this.button.disabled = false;
      this.button.querySelector('[data-label]').textContent = 'Try again';
    } finally {
      this.button.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('v4-bundle-add')) customElements.define('v4-bundle-add', V4BundleAdd);
